module.exports = __webpack_public_path__ + "static/media/dashboard.7286f311.png";